<template>
	<div>
		<v-layout class="p-4 border-bottom-light-grey min-height-57px">
			<v-flex class="font-level-3-bold my-auto">
				<span class="detail-svg-icon mr-2">
					<!--begin::Svg Icon-->
					<inline-svg :src="$assetURL('media/custom-svg/services-color.svg')" />
					<!--end::Svg Icon-->
				</span>
				Services
			</v-flex>
			<v-flex class="text-right my-auto"> Total Services Cost: {{ totalCost }} </v-flex>
		</v-layout>
		<div class="overflow-y" style="max-height: calc(100vh - 306px)">
			<table width="100%" class="detail-table table-head-sticky">
				<thead>
					<tr>
						<th width="20" class="p-2 light-blue-bg"></th>
						<th class="p-2 light-blue-bg">Type</th>
						<th class="p-2 light-blue-bg">Status</th>
						<th class="p-2 light-blue-bg">Description</th>
						<th class="p-2 light-blue-bg">Cost</th>
						<th class="p-2 light-blue-bg">Serviced By</th>
						<th class="p-2 light-blue-bg">Linked Perishables Items</th>
						<th class="p-2 light-blue-bg">Start Date (expected)</th>
						<th class="p-2 light-blue-bg">Start Date (actual)</th>
						<th class="p-2 light-blue-bg">End Date (expected)</th>
						<th class="p-2 light-blue-bg">End Date (actual)</th>
					</tr>
				</thead>
				<tbody v-if="services.length">
					<tr v-for="(row, index) in services" :key="index">
						<td v-on:click="routeToDetail(row)" width="20" class="p-2 cursor-pointer">
							<v-chip v-if="row.type == 1" color="blue darken-4" text-color="white">M</v-chip>
							<v-chip v-else color="amber darken-4" text-color="white">S</v-chip>
						</td>
						<td v-on:click="routeToDetail(row)" class="p-2 cursor-pointer">
							<ShowValue :object="row" object-key="service_type" label="Type"></ShowValue>
						</td>
						<td v-on:click="routeToDetail(row)" class="p-2 cursor-pointer">
							<v-chip v-if="row.status == 1" color="blue darken-4" text-color="white">Started</v-chip>
							<v-chip v-else-if="row.status == 2" color="green" text-color="white">Completed</v-chip>
							<v-chip v-else color="amber darken-4" text-color="white">Scheduled</v-chip>
						</td>
						<td v-on:click="routeToDetail(row)" class="p-2 cursor-pointer d-grid" width="200">
							<ShowValue :object="row" object-key="description" truncate label="Description"></ShowValue>
						</td>
						<td v-on:click="routeToDetail(row)" class="p-2 cursor-pointer">
							<ShowValue :object="row" object-key="cost_formatted" label="Cost"></ShowValue>
						</td>
						<td class="p-2">
							<template v-if="row.service_by == 1">
								Supplier (<ShowValue
									:object="row"
									object-key="supplier_display_name"
									label="Supplier"
								></ShowValue
								>)
							</template>
							<template v-else>
								Member (<ShowValue :object="row" object-key="member_display_name" label="Member"></ShowValue
								>)
							</template>
						</td>
						<td class="p-2">
							<ShowValue
								:object="row"
								object-key="linked_items"
								label="Linked Perishables Items"
							></ShowValue>
							<template v-if="row.linked_items > 0">(view)</template>
						</td>
						<td v-on:click="routeToDetail(row)" class="p-2 cursor-pointer">
							<ShowValue
								:object="row"
								object-key="expected_start_date_formatted"
								label="Start Date (expected)"
							></ShowValue>
						</td>
						<td v-on:click="routeToDetail(row)" class="p-2 cursor-pointer">
							<ShowValue
								:object="row"
								object-key="actual_start_date_formatted"
								label="Start Date (actual)"
							></ShowValue>
						</td>
						<td v-on:click="routeToDetail(row)" class="p-2 cursor-pointer">
							<ShowValue
								:object="row"
								object-key="expected_end_date_formatted"
								label="End Date (expected)"
							></ShowValue>
						</td>
						<td v-on:click="routeToDetail(row)" class="p-2 cursor-pointer">
							<ShowValue
								:object="row"
								object-key="actual_end_date_formatted"
								label="End Date (actual)"
							></ShowValue>
						</td>
					</tr>
				</tbody>
				<tfoot v-else>
					<tr>
						<td colspan="11">
							<p class="m-0 row-not-found text-center py-3">
								<img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
								Uhh... There are no service at the moment.
							</p>
						</td>
					</tr>
				</tfoot>
			</table>
		</div>
		<Dialog :dialog="detailDialog" :dialog-width="dialogWidth" dense>
			<template v-slot:title>
				<v-layout>
					<v-flex md4 class="my-auto"> {{ service.service_type }} Service </v-flex>
					<v-flex md8 class="text-right">
						<v-btn v-if="service.status == 3" color="blue darken-4 text-white" class="mr-2" depressed tile
							><v-icon small left>mdi-hammer-wrench</v-icon>Start</v-btn
						>
						<v-btn
							v-if="service.status == 1"
							v-on:click="serviceCompleteDialog = true"
							color="blue darken-4 text-white"
							class="mx-2"
							depressed
							tile
							><v-icon small left>mdi-format-list-checks</v-icon>Complete</v-btn
						>
						<v-btn
							v-if="service.status == 1"
							v-on:click="serviceExtendDialog = true"
							color="blue darken-4 text-white"
							class="mx-2"
							depressed
							tile
							><v-icon small left>mdi-share-all-outline</v-icon>Extend</v-btn
						>
						<v-btn
							v-on:click="detailDialog = false"
							color="blue darken-4 text-white"
							class="ml-2"
							depressed
							tile
							><v-icon small left>mdi-close</v-icon>Close</v-btn
						>
					</v-flex>
				</v-layout>
			</template>
			<template v-slot:body>
				<div>
					<v-tabs
						v-model="serviceTab"
						background-color="transparent"
						color="blue"
						class="custom-tab-transparent"
						active-class="blue darken-4 text-white"
						hide-slider
					>
						<v-tab href="#detail">
							<span class="tab-svg-icon mr-2">
								<!--begin::Svg Icon-->
								<inline-svg :src="$assetURL('media/custom-svg/services.svg')" />
								<!--end::Svg Icon-->
							</span>
							Details
						</v-tab>
						<v-tab href="#linked-inventory" v-on:click="getLinkedInventories()">
							<span class="tab-svg-icon mr-2">
								<!--begin::Svg Icon-->
								<inline-svg :src="$assetURL('media/custom-svg/inventory.svg')" />
								<!--end::Svg Icon-->
							</span>
							Linked Perishables
						</v-tab>
						<v-tab href="#file"> <v-icon small left>mdi-file-document-multiple</v-icon> Files</v-tab>
						<v-tab href="#comment"> <v-icon small left>mdi-comment-multiple</v-icon> Comments</v-tab>
					</v-tabs>
					<v-tabs-items v-model="serviceTab">
						<v-tab-item value="detail">
							<div class="mx-4 mb-4">
								<div class="overflow-y" style="max-height: 600px; min-height: 400px">
									<v-layout class="p-4 border-bottom-light-grey min-height-57px">
										<v-flex class="font-level-3-bold my-auto">
											<span class="detail-svg-icon mr-2">
												<!--begin::Svg Icon-->
												<inline-svg :src="$assetURL('media/custom-svg/services-color.svg')" />
												<!--end::Svg Icon-->
											</span>
											Service Details
										</v-flex>
									</v-layout>
									<table width="100%" class="detail-table scattered-table">
										<tr>
											<th class="p-2" width="250px">Service Type</th>
											<td class="font-level-1 p-2">
												<ShowValue :object="service" object-key="service_type" label="service type"></ShowValue>
											</td>
											<th class="p-2" width="250px">Service Start Date (expected)</th>
											<td class="font-level-1 p-2">
												<ShowValue
													:object="service"
													object-key="expected_start_date_formatted"
													label="service start date (expected)"
												></ShowValue>
											</td>
										</tr>
										<tr>
											<th class="p-2" width="250px">Cost</th>
											<td class="font-level-1 p-2">
												<ShowValue :object="service" object-key="cost_formatted" label="Cost"></ShowValue>
											</td>
											<th class="p-2" width="250px">Service End Date (expected)</th>
											<td class="font-level-1 p-2">
												<ShowValue
													:object="service"
													object-key="expected_end_date_formatted"
													label="Service End Date (expected)"
												></ShowValue>
											</td>
										</tr>
										<tr>
											<th class="p-2" width="250px">Service By</th>
											<td class="font-level-1 p-2">
												<ShowValue
													:object="service"
													object-key="service_by_formatted"
													label="Service By"
												></ShowValue>
												(
												<ShowValue
													:object="service"
													v-if="service.service_by == 1"
													object-key="supplier_display_name"
													label="supplier"
												></ShowValue>
												<ShowValue
													:object="service"
													v-else
													object-key="member_display_name"
													label="member"
												></ShowValue
												>)
											</td>
											<th class="p-2" width="250px">Service Start Date (actual)</th>
											<td class="font-level-1 p-2">
												<ShowValue
													:object="service"
													object-key="actual_start_date_formatted"
													label="service start date (actual)"
												></ShowValue>
											</td>
										</tr>
										<tr>
											<th class="p-2" width="250px">Created By</th>
											<td class="font-level-1 p-2">
												<ShowValue :object="service" object-key="created_by" label="Created By"></ShowValue>
											</td>
											<th class="p-2" width="250px">Service End Date (actual)</th>
											<td class="font-level-1 p-2">
												<ShowValue
													:object="service"
													object-key="actual_end_date_formatted"
													label="Service End Date (actual)"
												></ShowValue>
											</td>
										</tr>
										<tr>
											<th class="p-2" width="250px">Description</th>
											<td class="font-level-1 p-2" colspan="3">
												<ShowValue :object="service" object-key="description" label="Description"></ShowValue>
											</td>
										</tr>
									</table>
								</div>
							</div>
						</v-tab-item>
						<v-tab-item value="linked-inventory">
							<div class="mx-4 mb-4">
								<v-layout class="p-4 border-bottom-light-grey min-height-57px">
									<v-flex md6 class="font-level-3-bold my-auto">
										<table width="100%">
											<tr>
												<td>
													<span class="detail-svg-icon mr-2">
														<!--begin::Svg Icon-->
														<inline-svg :src="$assetURL('media/custom-svg/inventory-color.svg')" />
														<!--end::Svg Icon-->
													</span>
												</td>
												<td>
													<p class="m-0 mb-2">Linked Perishables</p>
													<span class="font-small text-muted">
														<v-icon small>mdi-progress-question</v-icon> Items displayed here were consumed during
														the service.</span
													>
												</td>
											</tr>
										</table>
									</v-flex>
									<v-flex md6 class="font-level-3-bold my-auto text-right">
										<v-btn v-on:click="inventoryDialog = true" color="blue darken-4 text-white" depressed tile
											><v-icon small left>mdi-playlist-plus</v-icon>Link Perishables Items</v-btn
										>
									</v-flex>
								</v-layout>
								<div
									class="overflow-y border-light-grey"
									style="max-height: calc(100vh - 250px); min-height: 400px"
								>
									<table width="100%" class="detail-table scattered-table table-head-sticky">
										<thead>
											<tr>
												<th class="p-2 light-blue-bg font-level-1-bold">Perishables #</th>
												<th class="p-2 light-blue-bg font-level-1-bold">Name</th>
												<th class="p-2 light-blue-bg font-level-1-bold">Quantity</th>
												<th class="p-2 light-blue-bg font-level-1-bold">Location</th>
												<th class="p-2 light-blue-bg font-level-1-bold">Date Added</th>
											</tr>
										</thead>
										<tbody v-if="linkedInventories.length">
											<tr v-for="(row, index) in linkedInventories" :key="index">
												<td class="border-top-light-grey border-right-light-grey font-level-1 p-2">
													<ShowValue
														:object="row"
														object-key="inventory_barcode"
														label="inventory #"
													></ShowValue>
												</td>
												<td class="border-top-light-grey border-right-light-grey font-level-1 p-2">
													<ShowValue :object="row" object-key="inventory_name" label="name"></ShowValue>
												</td>
												<td class="border-top-light-grey border-right-light-grey font-level-1 p-2">
													<ShowValue :object="row" object-key="quantity" label="quantity"></ShowValue>
												</td>
												<td class="border-top-light-grey border-right-light-grey font-level-1 p-2">
													<ShowValue :object="row" object-key="location_name" label="location"></ShowValue>
												</td>
												<td class="border-top-light-grey font-level-1 p-2">
													<ShowValue
														tooltip
														tooltip-value="added_at"
														:object="row"
														object-key="created_at"
														label="date added"
													></ShowValue>
												</td>
											</tr>
										</tbody>
										<tfoot v-else>
											<tr>
												<td colspan="5">
													<p class="m-0 row-not-found text-center">
														<img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
														Uhh... There are no linked inventory at the moment.
													</p>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							</div>
						</v-tab-item>
						<v-tab-item value="file">
							<Files
								class="mx-4"
								type-text="Service Files"
								type="service"
								:type-uuid="service.uuid"
							></Files>
						</v-tab-item>
						<v-tab-item value="comment">
							<Comments
								class="mx-4"
								type-text="Service"
								type="service"
								:type-uuid="service.uuid"
							></Comments>
						</v-tab-item>
					</v-tabs-items>
				</div>
			</template>
		</Dialog>
		<Dialog :dialog="inventoryDialog" :dialog-width="dialogWidth - 200" dense>
			<template v-slot:title> Link Perishables Items </template>
			<template v-slot:body>
				<LinkAssetInventoryItem v-model="inventories" class="mx-4 mb-4"></LinkAssetInventoryItem>
			</template>
			<template v-slot:action>
				<v-btn v-on:click="closeLinkInventory()" color="blue darken-4 text-white" depressed tile
					>Close</v-btn
				>
				<v-btn v-on:click="linkInventory()" color="blue darken-4 text-white" depressed tile
					>Link Perishables</v-btn
				>
			</template>
		</Dialog>
		<ServiceCompleteTemplate
			type="Asset"
			endpoint="asset"
			:type-uuid="uuid"
			:service-uuid="service.uuid"
			v-on:success="
				serviceCompleteDialog = false;
				detailDialog = false;
				getServices();
			"
			v-on:close="serviceCompleteDialog = false"
			:service-dialog="serviceCompleteDialog"
		></ServiceCompleteTemplate>
		<ServiceExtendTemplate
			type="Asset"
			endpoint="asset"
			:type-uuid="uuid"
			:service-uuid="service.uuid"
			v-on:success="
				serviceExtendDialog = false;
				detailDialog = false;
				getServices();
			"
			v-on:close="serviceExtendDialog = false"
			:service-dialog="serviceExtendDialog"
		></ServiceExtendTemplate>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { toSafeInteger } from "lodash";
import {
	GetServices,
	AssetServiceLinkInventory,
	GetAssetServiceLinkInventory,
} from "@/core/lib/asset.lib";
import ShowValue from "@/view/components/ShowValue";
import Dialog from "@/view/components/Dialog";
import Comments from "@/view/components/Comments";
import Files from "@/view/components/Files";
import ServiceCompleteTemplate from "@/view/components/ServiceCompleteTemplate";
import ServiceExtendTemplate from "@/view/components/ServiceExtendTemplate";
import LinkAssetInventoryItem from "@/view/components/LinkAssetInventoryItem";
import { SET_ERROR, SET_MESSAGE } from "@/core/services/store/common.module";
import { EventBus } from "@/core/event-bus/event.bus";

export default {
	data() {
		return {
			services: [],
			linkedInventories: [],
			inventoryList: [],
			inventories: [],
			pageLoading: false,
			detailDialog: false,
			inventoryDialog: false,
			serviceCompleteDialog: false,
			serviceExtendDialog: false,
			searchLoading: false,
			formLoading: false,
			menuSearch: false,
			showingString: null,
			search: null,
			serviceTab: "detail",
			currentPage: 1,
			totalCost: 0,
			totalPage: 1,
			service: {},
			timeout: null,
			timeoutLimit: 500,
		};
	},
	props: {
		uuid: {
			type: String,
			data: null,
		},
		type: {
			type: String,
			data: "asset",
		},
	},
	methods: {
		closeLinkInventory() {
			this.inventoryList = [];
			this.inventories = [];
			this.inventoryDialog = false;
			this.searchLoading = false;
			this.formLoading = false;
			this.menuSearch = false;
			this.search = null;
		},
		getLinkedInventories() {
			if (!this.service.uuid) {
				return false;
			}

			GetAssetServiceLinkInventory(this.uuid, this.service.uuid)
				.then((data) => {
					this.linkedInventories = data;
				})
				.catch((error) => {
					this.logError(error);
				});
		},
		linkInventory() {
			if (!this.service.uuid) {
				return false;
			}

			if (!this.inventories.length) {
				this.$store.commit(
					SET_ERROR,
					this.errors.concat([{ model: true, message: "Error ! Add atleast one inventory." }])
				);
				return false;
			}

			this.formLoading = true;
			AssetServiceLinkInventory(this.uuid, this.service.uuid, { inventory: this.inventories })
				.then((data) => {
					this.linkedInventories = data;
					this.closeLinkInventory();
					this.$store.commit(SET_MESSAGE, [
						{ model: true, message: "Success ! Perishables has been successfully linked to service." },
					]);
				})
				.catch((error) => {
					this.logError(error);
				})
				.finally(() => {
					this.formLoading = false;
				});
		},
		routeToDetail(row) {
			console.log({ row });
			this.service = row;
			this.detailDialog = true;
		},
		getServices() {
			GetServices(this.type, this.uuid)
				.then((data) => {
					this.services = data.tbody;
					this.showingString = data.showing_string;
					this.currentPage = data.current_page;
					this.totalCost = data.total_cost_formatted;
					this.totalPage = data.total_page;
				})
				.catch((error) => {
					this.logError(error);
				})
				.finally(() => {
					this.pageLoading = false;
				});
		},
	},
	components: {
		Dialog,
		ShowValue,
		Comments,
		Files,
		ServiceExtendTemplate,
		LinkAssetInventoryItem,
		ServiceCompleteTemplate,
	},
	mounted() {
		this.getServices();

		EventBus.$on("reload:asset-service", () => {
			this.getServices();
		});
	},
	beforeDestroy() {
		EventBus.$off("reload:asset-service");
	},
	computed: {
		...mapGetters(["errors"]),
		dialogWidth() {
			return toSafeInteger((document.body.clientWidth / 100) * 65);
		},
	},
};
</script>
